<template>
  <div
    :class="[
      'app-page-section-wrapper',
      `app-page-section-wrapper--bottom-line-${bottomLineClass}`,
      `app-page-section-wrapper--top-line-${topLineClass}`,
    ]"
  >
    <Component :is="tag" :class="['app-page-section', internalClass]" :style="sectionStyles">
      <slot />
    </Component>
  </div>
</template>

<script>
export default {
  props: {
    backgroundColor: {
      type: String,
      default: null,
    },
    bottomLine: {
      type: String,
      default: 'none',
      validator: (val) =>
        ['none', 'max-width', 'full-width', 'small-width', 'max_width', 'full_width', 'small_width'].includes(val),
    },
    topLine: {
      type: String,
      default: 'none',
      validator: (val) =>
        ['none', 'max-width', 'full-width', 'small-width', 'max_width', 'full_width', 'small_width'].includes(val),
    },
    tag: {
      type: String,
      default: 'div',
      validator: (val) => ['div', 'section'].includes(val),
    },
    verticalPadding: {
      type: Number,
      default: 80,
      validator: (val) => val >= 0,
    },
    paddingTop: {
      type: Number,
      default: null,
      validator: (val) => val === null || val >= 0,
    },
    paddingBottom: {
      type: Number,
      default: null,
      validator: (val) => val === null || val >= 0,
    },
    internalClass: {
      type: String,
      default: null,
    },
  },
  computed: {
    bottomLineClass() {
      return this.bottomLine.replace('_', '-');
    },
    topLineClass() {
      return this.topLine.replace('_', '-');
    },
    sectionStyles() {
      let paddingTop = this.paddingTop !== null ? this.paddingTop : this.verticalPadding;
      paddingTop = paddingTop >= 0 ? paddingTop : 0;
      const paddingTopMobile = Math.min(paddingTop, 56);

      let paddingBottom = this.paddingBottom !== null ? this.paddingBottom : this.verticalPadding;
      paddingBottom = paddingBottom >= 0 ? paddingBottom : 0;
      const paddingBottomMobile = Math.min(paddingBottom, 56);

      return {
        '--padding-top-mobile': `${paddingTopMobile}px`,
        '--padding-bottom-mobile': `${paddingBottomMobile}px`,
        '--padding-top-desktop': `${paddingTop}px`,
        '--padding-bottom-desktop': `${paddingBottom}px`,
        backgroundColor: this.backgroundColor || null,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-page-section-wrapper {
  &:not(:last-child, &--bottom-line-none) {
    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 2px;
      margin: 0 auto;
      background-color: vars.$c-gray-cc;
    }
  }

  &:not(:first-child, &--top-line-none) {
    &::before {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      margin: 0 auto;
      background-color: vars.$c-gray-cc;
    }
  }

  &--bottom-line-max-width {
    &::after {
      max-width: 1196px;
    }
  }

  &--top-line-max-width {
    &::before {
      max-width: 1196px;
    }
  }

  &--bottom-line-small-width {
    &::after {
      max-width: 300px;
    }
  }

  &--top-line-small-width {
    &::after {
      max-width: 300px;
    }
  }
}

.app-page-section {
  background-color: vars.$c-total-white;
  padding-top: var(--padding-top-mobile);
  padding-bottom: var(--padding-bottom-mobile);

  @media (min-width: vars.$tablet-break-point + 1) {
    padding-top: var(--padding-top-desktop);
    padding-bottom: var(--padding-bottom-desktop);
  }
}
</style>
